import styled from 'styled-components';
import { Box } from '@components/Box';
import { themeSpace, themeColor, themeMediaQuery } from '@utils/styledTheme.util';
import { CloudImage } from '@components/CloudImage';
import { Text } from '@components/typography';

export const EmotionalBreakSectionWrap = styled(Box)`
  width: 100%;
`;

export const LottieWrapper = styled(Box)`
  width: 100%;
  height: 72vw;
  min-height: 500px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(82, 73, 63, 0.15) 29.17%,
    rgba(82, 73, 63, 0.2) 79.17%,
    rgba(255, 255, 255, 0) 100%
  );
  position: relative;
`;

export const LottieContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ContentWrapper = styled(Box)`
  margin: ${themeSpace(0)};
  top: 11vw;
  padding: ${themeSpace(7)};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
`;

export const BoxStyle = styled(Box)`
  margin: ${themeSpace(0)};
  background-color: ${themeColor('black')};
  opacity: 0.4;
  width: 100%;
  height: 100%;
`;

export const LottieFirstFrame = styled(CloudImage)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const StyledTextContainer = styled(Text)`
  max-width: 580px;
  ${themeMediaQuery('xl')} {
    max-width: 790px;
  }
`;
